
import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import {
    InnerWrapper
} from './overlay.style';
import Overlay from '../../../Overlay/Overlay';
import { ModalTypes } from '../../../AtBat/atbat.style';

const BALL_CLASSNAME = 'responsive-pitch-fx-ball';
const OVERLAYEVENTS = ['mouseover', 'ontouchstart'];

const PitchFxOverlay = () => {
    const [pitchNum, setPitchNum] = useState(0);
    const [pitchContent, setPitchContent] = useState(null);

    const resetContent = () => {
        setPitchNum(0);
        setPitchContent(null);
    };
    const onBallPick = (e) => {
        const { target } = e;
        const isBall = target?.classList?.contains(BALL_CLASSNAME);
        if (isBall) {
            const ballNum = target?.dataset?.pitchNum;
            setPitchNum(ballNum);
            setPitchContent(document.querySelectorAll('.responsive-pitch-fx-data-description.responsive-pitch-fx-pitch-' + ballNum)[0].innerHTML);
        }
    };

    const onClose = (e) => {
        const { target } = e;
        const isBall = target?.classList?.contains(BALL_CLASSNAME);
        if (!isBall) {
            resetContent();
        }
    };

    useEffect(() => {
        if (typeof window !== 'undefined' && typeof window.document !== 'undefined') {
            OVERLAYEVENTS.forEach(evt => document.addEventListener(evt, onBallPick, false));

            return () => {
                OVERLAYEVENTS.forEach(evt => document.removeEventListener(evt, onBallPick, false));
            };
        }
    }, []);

    const createMarkup = () => { return { __html: pitchContent }; };
    return (
        <Overlay
            isOpen={pitchNum !== 0}
            onClose={onClose}
            type={ModalTypes.VERTICAL}
            className='pitchFx-overlay'
            backdropEventType='onPointerDown'

        >
            <InnerWrapper dangerouslySetInnerHTML={createMarkup()} />
        </Overlay>
    );
};

PitchFxOverlay.propTypes = {
    hoverData: PropTypes.object
};

export default PitchFxOverlay;
